class OrderManagementEditDeliveryController {
    constructor($element, orderManagementService, moveFocus) {
        this.$element = $element;
        this.orderManagementService = orderManagementService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.timeTable = [];
        this.isDelivery = this.order.DeliveryMethod === 'Courier';
        this.orderManagementService.getPastOrderDeliveryWindow(this.order.OrderId, this.isDelivery).then(() => {
            this.timeTable = this.orderManagementService.timeTable;
        });
    }

    setDate(selectedDate) {
        this.selectedDate = selectedDate;
    }

    setTime(fulfilmentTime) {
        this.modalMessage = null;
        // Save th delivery info
        this.orderManagementService.savePastOrderDeliveryWindow(this.order.OrderId, fulfilmentTime.Id, this.selectedDate.Date).then((response) => {
            if (!response.IsSuccessful) {
                this.modalMessage = response.Message;
            } else {
                // Need to refresh the pending order pages.
                this.orderManagementService.invalidate();
                this.orderManagementService.getOrders();
            }
        });
    }

    resetModalMessage() {
        this.modalMessage = null;

        let elementToFocus = this.$element.find('.deliveryTimetable-windows .list-group-itemLink.active');

        if (elementToFocus.length === 0) {

            elementToFocus = this.$element.find('.deliveryTimetable-windows .list-group-itemLink:first');
        }

        // Move focus back to active time link
        this.moveFocus(elementToFocus);
    }
}

const orderManagementEditDeliveryComponentDefinition = {
    bindings: {
        order: '<',
    },
    controller: ['$element', 'OrderManagementService', 'MoveFocus', OrderManagementEditDeliveryController],
    template: require('./order-management-edit-delivery.component.html').trim(),
};

module.exports = {
    OrderManagementEditDeliveryController,
    orderManagementEditDeliveryComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management-edit-delivery.component.js